import { render } from "./DownloadItem.vue?vue&type=template&id=3bf39be4&scoped=true"
import script from "./DownloadItem.vue?vue&type=script&lang=js"
export * from "./DownloadItem.vue?vue&type=script&lang=js"

import "./DownloadItem.vue?vue&type=style&index=0&id=3bf39be4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf39be4"]])

export default __exports__